<template>
  <b-button @click="favorite" class="bt btn-addFavoris mt-4">
      <p class="title">{{title}}</p>
      <span>
        <font-awesome-icon :icon="['fal', 'star']" v-if="!thisIsFavorite"/>
        <font-awesome-icon :icon="['fas', 'star']" v-if="thisIsFavorite"/>
      </span>
  </b-button>
</template>


<script>

export default {
name:"btAddFavoris",
  props:{
    title:{
      type:String,
      default:'Ajouter ce critère au favoris'
      },
    isFavorite:{
      type:Boolean,
      default:false
    }
  },
data(){
  return {
    thisIsFavorite:false
  }
},
mounted () {
  this.thisIsFavorite = this.isFavorite
},
methods:{
  favorite(){
    this.$emit('favorite');
    this.thisIsFavorite = !this.thisIsFavorite;
  }
}
}
</script>